import { AxiosResponse, Canceler } from 'axios';
import { ILinkResponse, ILink } from '../types';
import settings from '../settings';
import api from './base';

export function getLinks(page = 1, limit = 20): [Promise<AxiosResponse<ILinkResponse>>, Canceler] {
  const uri = `${settings.getApiURI()}/link/v1/links`;

  return api.getWithCancel(uri, {
    params: {
      limit,
      page,
    },
  });
}

export function getLink(id: number): [Promise<AxiosResponse<ILink>>, Canceler] {
  const uri = `${settings.getApiURI()}/link/v1/links/${id}`;

  return api.getWithCancel(uri);
}

export function createLink(payload: Partial<ILink>): Promise<AxiosResponse<ILink>> {
  const uri = `${settings.getApiURI()}/link/v1/links`;
  return api.http.post(uri, payload);
}

export function editLink(id: number, payload: Partial<ILink>): Promise<AxiosResponse<ILink>> {
  const uri = `${settings.getApiURI()}/link/v1/links/${id}`;
  return api.http.put(uri, payload);
}

export function deleteLink(id: number): Promise<AxiosResponse<ILink>> {
  const uri = `${settings.getApiURI()}/link/v1/links/${id}`;
  return api.http.delete(uri);
}
